import { ASSETS } from "../lib/brand";
import { useReveal } from "../hooks/useReveal";

export const Rentals = () => {
  const imgRef = useReveal();
  const txtRef = useReveal();

  const inclusions = [
    "Bag & hardcase",
    "Batteries & charger",
    "Silicone case & wrist strap",
    "128 GB SD card",
    "Card reader (USB-C)",
  ];

  return (
    <section
      id="rentals"
      data-testid="rentals-section"
      className="py-24 md:py-40 border-b border-black/100"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-12 md:mb-16">
          <div>
            <div className="label-eyebrow mb-4">The Lineup · Vol. III</div>
            <h2 className="font-display text-[2.6rem] md:text-7xl leading-[0.95] tracking-[-0.015em]">
              The <span className="italic">instrument.</span>
            </h2>
          </div>
          <span className="label-eyebrow hidden md:block opacity-60">
            Featured · 01 of 01
          </span>
        </div>

        <div className="grid grid-cols-12 gap-8 md:gap-16 items-start">
          {/* Product visual */}
          <div
            ref={imgRef}
            className="col-span-12 md:col-span-7 reveal"
          >
            <div className="relative overflow-hidden bg-[#F5F5F3] aspect-[4/3] flex items-center justify-center">
              <img
                src={ASSETS.product1}
                alt="Canon G7X Mark III — clean product shot"
                data-testid="rentals-product-image"
                loading="lazy"
                className="editorial-img w-full h-full object-contain p-6 md:p-10"
              />
            </div>
          </div>

          {/* Spec sheet */}
          <div
            ref={txtRef}
            className="col-span-12 md:col-span-5 reveal reveal-delay-2"
          >
            <div className="label-eyebrow mb-4">N° 001</div>
            <h3
              data-testid="rentals-product-name"
              className="font-display text-4xl md:text-5xl leading-[0.95] tracking-tight"
            >
              Canon G7X <br />
              <span className="italic">Mark III</span>
            </h3>

            <div className="mt-10 border-t border-black/100 pt-6">
              <div className="label-micro mb-4">Inclusions</div>
              <ul className="space-y-3">
                {inclusions.map((it, i) => (
                  <li
                    key={i}
                    data-testid={`rental-inclusion-${i}`}
                    className="flex items-baseline justify-between border-b border-black/10 pb-3 font-body text-[15px]"
                  >
                    <span>{it}</span>
                    <span className="label-micro opacity-60">Incl.</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-6">
              <div>
                <div className="label-micro mb-2">Rates</div>
                <div
                  data-testid="rentals-pricing-note"
                  className="font-display italic text-xl md:text-2xl leading-tight"
                >
                  Contact us for pricing.
                </div>
              </div>
              <div>
                <div className="label-micro mb-2">Hours</div>
                <div className="font-display text-xl md:text-2xl leading-tight">
                  Open daily<br />
                  <span className="italic">8AM — 10PM</span>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="#contact"
                data-testid="rentals-cta-inquire"
                className="btn-pill btn-pill-solid"
              >
                Inquire &amp; book
              </a>
              <a
                href="#contact"
                data-testid="rentals-cta-pricing"
                className="btn-pill"
              >
                Request pricing
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
